import {Select} from "@/theme/ui";
import {useApi} from "@/lib/hook";
import {useSession} from "next-auth/react";

export const UserRoleSelect = ({value, onChange, ...rest}) => {
    const { data: session } = useSession();
    const {data} = useApi({
        route: {name: 'admins.roles.all'},
        setting: {
            select: (data) => data.data,
            staleTime: Infinity,
        }
    })

    return (
        <>
            <Select
                style={{
                    width: '100%',
                }}
                value={value}
                onChange={onChange}
                disabled={session?.user?.role === 'SuperAdmin' ? false : true}
                options={data}
                fieldNames={{value: 'id', label: 'name'}}
                {...rest}
            />
        </>
    );
}